module.exports = "/assets/b39a64d0b421053cbf8562da124bcbae.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/3L.png
// module id = 2143
// module chunks = 0